import { MainUserLayout } from "layout";
import {
  BalancePage,
  BuyProxyPage,
  ChangeIpPage,
  MyProxiesPage,
  ReferralNetworkPage,
  SettingsPage,
  SupportPage,
} from "pages/user";
import { redirect, RouteObject } from "react-router-dom";

export const mainUserRouter: RouteObject[] = [
  {
    path: "*",
    loader() {
      return redirect("/");
    },
  },
  {
    path: "/",
    element: <MainUserLayout />,
    children: [
      {
        index: true,
        element: <MyProxiesPage />,
      },
      {
        path: "buy-proxy",
        element: <BuyProxyPage />,
      },

      {
        path: "balance",
        element: <BalancePage />,
      },
      {
        path: "referral-program",
        element: <ReferralNetworkPage />,
      },
      {
        path: "settings",
        element: <SettingsPage />,
      },
      {
        path: "support",
        element: <SupportPage />,
      }
    ],
  },
  {
    path: "change-ip",
    element: <ChangeIpPage />,
  },
];
